(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("core-js/modules/es.array.from.js"), require("core-js/modules/es.string.iterator.js"), require("@splat/constant"), require("@splat/theme"), require("@splat/iconfont"), require("@splat/validator"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"));
	else if(typeof define === 'function' && define.amd)
		define(["core-js/modules/es.array.from.js", "core-js/modules/es.string.iterator.js", , , , , , , , , , "core-js/modules/esnext.global-this.js"], factory);
	else if(typeof exports === 'object')
		exports["upload"] = factory(require("core-js/modules/es.array.from.js"), require("core-js/modules/es.string.iterator.js"), require("@splat/constant"), require("@splat/theme"), require("@splat/iconfont"), require("@splat/validator"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"));
	else
		root["upload"] = factory(root["core-js/modules/es.array.from.js"], root["core-js/modules/es.string.iterator.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_core_js_modules_es_array_from_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_string_iterator_js__, __WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE__splat_iconfont__, __WEBPACK_EXTERNAL_MODULE__splat_validator__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/item.tsx":
/*!**********************!*\
  !*** ./src/item.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _progress__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./progress */ "./src/progress.tsx");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var Item = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Item, _tsx$Component);

  var _super = _createSuper(Item);

  function Item() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "index", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Item, [{
    key: "onRetry",
    value: function onRetry(item, index) {
      this.$emit('retry', item, index);
    }
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {
      this.$emit('remove', item, index);
    }
  }, {
    key: "onCancel",
    value: function onCancel(item, index) {
      this.$emit('cancel', item, index);
    }
  }, {
    key: "handleRetry",
    value: function handleRetry() {
      var value = this.value,
          index = this.index,
          onRetry = this.onRetry;

      if (value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.failed) {
        onRetry(value, index);
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      var value = this.value,
          index = this.index,
          onRemove = this.onRemove,
          onCancel = this.onCancel;

      if (value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.done) {
        onRemove(value, index);
      } else {
        onCancel(value, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value;
      return h("li", {
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemClassName
      }, [h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemContentClassName
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.uploadItemTextClassName, value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.done && _style__WEBPACK_IMPORTED_MODULE_9__.doneUploadItemTextClassName)
      }, [value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.done ? h("i", {
        "class": 'el-icon-document'
      }) : value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.failed ? h("i", {
        "class": 'el-icon-warning'
      }) : value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.uploading ? h("i", {
        "class": 'el-icon-loading'
      }) : null, h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemTextFileNameClassName
      }, [value.filename])]), h("div", [value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.failed ? h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)('el-icon-refresh', _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemOperationClassName),
        "on": {
          "click": this.handleRetry
        }
      }) : null, h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)('el-icon-close', _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemOperationClassName),
        "on": {
          "click": this.handleRemove
        }
      })])]), value.status !== _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.done ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.uploadItemProgressClassName
      }, [value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.uploading ? h(_progress__WEBPACK_IMPORTED_MODULE_8__["default"], {
        "attrs": {
          "value": value.process,
          "type": value.status
        }
      }) : value.status === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.failed ? h(_progress__WEBPACK_IMPORTED_MODULE_8__["default"], {
        "attrs": {
          "value": 100,
          "type": value.status
        }
      }) : null]) : null]);
    }
  }]);

  return Item;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Item.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Item.prototype, "index", void 0);

Item = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component], Item);
/* harmony default export */ __webpack_exports__["default"] = (Item);

/***/ }),

/***/ "./src/list.tsx":
/*!**********************!*\
  !*** ./src/list.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_8__);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var List = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__["default"])(List, _tsx$Component);

  var _super = _createSuper(List);

  function List() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, List);

    return _super.apply(this, arguments);
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(List, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      return h("ul", {
        "class": _style__WEBPACK_IMPORTED_MODULE_6__.uploadListClassName
      }, [this.$slots.default]);
    }
  }]);

  return List;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_8__.Component);

List = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_7__.Component], List);
/* harmony default export */ __webpack_exports__["default"] = (List);

/***/ }),

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    upload: {
      file: 'files',
      click: 'click here',
      drag: function drag(options) {
        return ['Drag and drop ', options.placeholder, ' here or'].join('');
      },
      up: 'upload files'
    }
  },
  'zh-CHT': {
    upload: {
      file: "\u6587\u4EF6",
      click: "\u9EDE\u64CA\u4E0A\u50B3",
      drag: function drag(options) {
        return ["\u5C07", options.placeholder, "\u62D6\u5230\u6B64\u8655\uFF0C\u6216"].join('');
      },
      up: "\u4E0A\u50B3\u6587\u4EF6"
    }
  },
  'zh-CN': {
    upload: {
      file: "\u6587\u4EF6",
      click: "\u70B9\u51FB\u4E0A\u4F20",
      drag: function drag(options) {
        return ["\u5C06", options.placeholder, "\u62D6\u5230\u6B64\u5904\uFF0C\u6216"].join('');
      },
      up: "\u4E0A\u4F20\u6587\u4EF6"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/progress.tsx":
/*!**************************!*\
  !*** ./src/progress.tsx ***!
  \**************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var Progress = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Progress, _tsx$Component);

  var _super = _createSuper(Progress);

  function Progress() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Progress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "type", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Progress, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          type = this.type,
          theme = this.theme;
      return h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.uploadProgressClassName
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.uploadProgressInnerClassName, type === _types__WEBPACK_IMPORTED_MODULE_10__.FileStatus.failed ? _style__WEBPACK_IMPORTED_MODULE_9__.failedProgressInnerClassName : _style__WEBPACK_IMPORTED_MODULE_9__.uploadingProgressInnerClassName(theme)),
        "style": {
          width: (0,csx__WEBPACK_IMPORTED_MODULE_11__.percent)(value)
        }
      })]);
    }
  }]);

  return Progress;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Progress.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Progress.prototype, "type", void 0);

Progress = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_8___default())]
})], Progress);
/* harmony default export */ __webpack_exports__["default"] = (Progress);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uploadContainerClassName": function() { return /* binding */ uploadContainerClassName; },
/* harmony export */   "uploadZoneContainerClassName": function() { return /* binding */ uploadZoneContainerClassName; },
/* harmony export */   "hiddenUploadClassName": function() { return /* binding */ hiddenUploadClassName; },
/* harmony export */   "uploadIconClassName": function() { return /* binding */ uploadIconClassName; },
/* harmony export */   "uploadTextClassName": function() { return /* binding */ uploadTextClassName; },
/* harmony export */   "uploadTextButtonClassName": function() { return /* binding */ uploadTextButtonClassName; },
/* harmony export */   "uploadListClassName": function() { return /* binding */ uploadListClassName; },
/* harmony export */   "uploadItemClassName": function() { return /* binding */ uploadItemClassName; },
/* harmony export */   "uploadItemContentClassName": function() { return /* binding */ uploadItemContentClassName; },
/* harmony export */   "uploadItemTextClassName": function() { return /* binding */ uploadItemTextClassName; },
/* harmony export */   "uploadItemTextFileNameClassName": function() { return /* binding */ uploadItemTextFileNameClassName; },
/* harmony export */   "uploadItemOperationClassName": function() { return /* binding */ uploadItemOperationClassName; },
/* harmony export */   "doneUploadItemTextClassName": function() { return /* binding */ doneUploadItemTextClassName; },
/* harmony export */   "uploadItemProgressClassName": function() { return /* binding */ uploadItemProgressClassName; },
/* harmony export */   "uploadProgressClassName": function() { return /* binding */ uploadProgressClassName; },
/* harmony export */   "uploadProgressInnerClassName": function() { return /* binding */ uploadProgressInnerClassName; },
/* harmony export */   "uploadingProgressInnerClassName": function() { return /* binding */ uploadingProgressInnerClassName; },
/* harmony export */   "failedProgressInnerClassName": function() { return /* binding */ failedProgressInnerClassName; },
/* harmony export */   "zoneFailedValidateStatusMessageClassName": function() { return /* binding */ zoneFailedValidateStatusMessageClassName; },
/* harmony export */   "zoneSuccessValidateStatusClassName": function() { return /* binding */ zoneSuccessValidateStatusClassName; },
/* harmony export */   "zoneFailedValidateStatusClassName": function() { return /* binding */ zoneFailedValidateStatusClassName; },
/* harmony export */   "zoneContainerValidateStatusClassName": function() { return /* binding */ zoneContainerValidateStatusClassName; },
/* harmony export */   "buttonFont": function() { return /* binding */ buttonFont; },
/* harmony export */   "buttonPlaceholder": function() { return /* binding */ buttonPlaceholder; },
/* harmony export */   "buttonIconSpace": function() { return /* binding */ buttonIconSpace; },
/* harmony export */   "buttonBackground": function() { return /* binding */ buttonBackground; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_3__);




var uploadContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_1__.width)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.width)), {});
var uploadZoneContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_1__.vertical, csstips__WEBPACK_IMPORTED_MODULE_1__.aroundJustified, csstips__WEBPACK_IMPORTED_MODULE_1__.center, (0,csstips__WEBPACK_IMPORTED_MODULE_1__.height)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.height)), {
  $nest: {
    '& > i': {
      paddingTop: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(18)
    }
  },
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.background.toString(),
  border: (0,csx__WEBPACK_IMPORTED_MODULE_2__.border)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.border.toString(),
    style: 'dashed',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(1)
  }),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.raduisSize)
});
var hiddenUploadClassName = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.hiddenInputClassName;
var uploadIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.icon.toString(),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.iconSize),
  $nest: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
});
var uploadTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.textSize),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.lineHeight),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.font.toString(),
  textAlign: 'center'
});
var uploadTextButtonClassName = function uploadTextButtonClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.themeTextButton(theme).toString(),
    $nest: {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  });
};
var uploadListClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_1__.margin)(0), (0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.menuTopBottomPadding), 0), {});
var uploadItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  listStyleType: 'none'
});
var uploadItemContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_1__.betweenJustified, {
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.uploadingFont.toString()
});
var uploadItemTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({});
var uploadItemTextFileNameClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.textCollision)
});
var uploadItemOperationClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  cursor: 'pointer'
});
var doneUploadItemTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.font.toString()
});
var uploadItemProgressClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({});
var uploadProgressClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.progressBackground.toString()
});
var uploadProgressInnerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.uploadProgressTransition, {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.progressHeight)
});
var uploadingProgressInnerClassName = function uploadingProgressInnerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.themeUploading(theme).toString()
  });
};
var failedProgressInnerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadColors.failed.toString()
});
var zoneFailedValidateStatusMessageClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  position: 'absolute',
  left: 0,
  top: (0,csx__WEBPACK_IMPORTED_MODULE_2__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100), " + ").concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(2))),
  color: '#C55252',
  lineHeight: 1,
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12)
});
var zoneSuccessValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  borderColor: '#35B053'
});
var zoneFailedValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  borderColor: '#C55252'
});
var zoneContainerValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.layerParent, {
  marginBottom: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(10)
});
var buttonFont = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  display: 'inline-block',
  maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.UploadSizes.width),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(14),
  color: '#333'
});
var buttonPlaceholder = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(8),
  color: 'rgba(0,0,0,0.45)'
});
var buttonIconSpace = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(8)
});
var buttonBackground = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(5), (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12)), {
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(5),
  background: '#F5F5F5',
  cursor: 'pointer',
  $nest: {
    '&:hover': {
      background: '#E9E9E9'
    }
  }
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FileStatus": function() { return /* binding */ FileStatus; }
/* harmony export */ });
var FileStatus;

(function (FileStatus) {
  FileStatus[FileStatus["idle"] = 0] = "idle";
  FileStatus[FileStatus["done"] = 1] = "done";
  FileStatus[FileStatus["uploading"] = 2] = "uploading";
  FileStatus[FileStatus["failed"] = 3] = "failed";
})(FileStatus || (FileStatus = {}));

/***/ }),

/***/ "./src/zone.tsx":
/*!**********************!*\
  !*** ./src/zone.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/iconfont */ "@splat/iconfont");
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_iconfont__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./item */ "./src/item.tsx");
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./list */ "./src/list.tsx");
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_20__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var UploadZone = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(UploadZone, _tsx$Component);

  var _super = _createSuper(UploadZone);

  function UploadZone() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, UploadZone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "uploadCallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "multiple", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "buttonType", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "dragEnter", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_formItemInstance", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "validateState", {
      type: _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.unknown
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_14__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(UploadZone, [{
    key: "formItemInstance",
    get: function get() {
      var _formItemInstance = this._formItemInstance;
      return _formItemInstance ? _formItemInstance() : null;
    }
  }, {
    key: "updateState",
    value: function updateState(v) {
      this.validateState = v;
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "onRemove",
    value: function onRemove(v) {}
  }, {
    key: "isMultiple",
    value: function isMultiple() {
      return !!this.multiple;
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, {
    key: "handleFileDrag",
    value: function handleFileDrag(e) {
      this.dragEnter = false;
      this.handleDragOver(e);

      if (e.dataTransfer) {
        this.handleSelectFile(Array.from(e.dataTransfer.files));
      }
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      this.dragEnter = false;
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter() {
      this.dragEnter = true;
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave() {
      this.dragEnter = false;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var input = e.target;

      if (input.files) {
        this.handleSelectFile(Array.from(input.files));
        input.value = '';
      }
    }
  }, {
    key: "shellUploadCallback",
    value: function shellUploadCallback(file, info) {
      this.uploadCallback(file, function (status, payload) {
        switch (status) {
          case _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.idle:
            Object.assign(info, _objectSpread(_objectSpread({}, info), {}, {
              status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.idle
            }));
            break;

          case _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.uploading:
            Object.assign(info, _objectSpread(_objectSpread({}, info), {}, {
              status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.uploading,
              process: payload
            }));
            break;

          case _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.done:
            Object.assign(info, _objectSpread(_objectSpread({}, info), {}, {
              status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.done,
              id: payload
            }));
            break;

          case _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.failed:
            Object.assign(info, _objectSpread(_objectSpread({}, info), {}, {
              file: file,
              status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.failed
            }));
            break;
        }
      });
    }
  }, {
    key: "handleSelectFile",
    value: function handleSelectFile(files) {
      if (!files || !files.length) return;
      var infos = files.map(function (file) {
        return {
          file: file,
          filename: file.name,
          status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.idle,
          process: 0,
          id: ''
        };
      });
      this.shellUploadCallback(files[0], infos[0]);

      if (this.isMultiple()) {
        this.onInput(this.value.concat(infos));

        if (this.formItemInstance) {
          this.validateState = this.formItemInstance.onChanged();
        }
      } else {
        this.onInput(infos[0]);

        if (this.formItemInstance) {
          this.validateState = this.formItemInstance.onChanged();
        }
      }
    }
  }, {
    key: "handleItemCancel",
    value: function handleItemCancel(item, index) {
      var onInput = this.onInput;

      if (this.isMultiple()) {
        onInput((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.remove)(this.value, index));

        if (this.formItemInstance) {
          this.validateState = this.formItemInstance.onChanged();
        }
      } else {
        onInput(null);

        if (this.formItemInstance) {
          this.validateState = this.formItemInstance.onChanged();
        }
      }
    }
  }, {
    key: "handleItemRemove",
    value: function handleItemRemove(item, index) {
      this.onRemove(item);
      this.handleItemCancel(item, index);
    }
  }, {
    key: "handleItemRetry",
    value: function handleItemRetry(item) {
      Object.assign(item, _objectSpread(_objectSpread({}, item), {}, {
        status: _types__WEBPACK_IMPORTED_MODULE_16__.FileStatus.uploading,
        process: 0
      }));
      this.shellUploadCallback(item.file, item);
    }
  }, {
    key: "renderValidateStatus",
    value: function renderValidateStatus() {
      var h = this.$createElement;
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.failed:
          return h("span", {
            "class": _style__WEBPACK_IMPORTED_MODULE_15__.zoneFailedValidateStatusMessageClassName
          }, [validateState.error]);

        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.success:
        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "zoneValidateStatusClassName",
    get: function get() {
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.failed:
          return _style__WEBPACK_IMPORTED_MODULE_15__.zoneFailedValidateStatusClassName;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.success:
          return null;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "containerValidateStateClassName",
    get: function get() {
      return this.validateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_11__.Status.failed ? _style__WEBPACK_IMPORTED_MODULE_15__.zoneContainerValidateStatusClassName : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          placeholder = this.placeholder,
          buttonType = this.buttonType,
          onClick = this.onClick,
          handleInput = this.handleInput,
          handleItemRemove = this.handleItemRemove,
          handleItemCancel = this.handleItemCancel,
          handleItemRetry = this.handleItemRetry,
          handleDragOver = this.handleDragOver,
          handleDragEnd = this.handleDragEnd,
          handleDragEnter = this.handleDragEnter,
          handleDragLeave = this.handleDragLeave,
          handleFileDrag = this.handleFileDrag,
          renderValidateStatus = this.renderValidateStatus,
          zoneValidateStatusClassName = this.zoneValidateStatusClassName,
          containerValidateStateClassName = this.containerValidateStateClassName,
          theme = this.theme,
          multiple = this.multiple;
      return buttonType ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.buttonFont
      }, [h("label", {
        "on": {
          "click": onClick
        },
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.buttonBackground
      }, [h("input", {
        "attrs": {
          "type": 'file',
          "multiple": multiple
        },
        "ref": 'input',
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.hiddenUploadClassName,
        "on": {
          "change": handleInput,
          "click": (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.eventStop)()
        }
      }), h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)('iconfont iconshangchuan', _style__WEBPACK_IMPORTED_MODULE_15__.buttonIconSpace)
      }), this.i18n.t.upload.up]), value && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.arrayify)(value).length ? h("div", [h(_list__WEBPACK_IMPORTED_MODULE_13__["default"], [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.arrayify)(value).map(function (x, i) {
        return h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
          "attrs": {
            "value": x,
            "index": i
          },
          "on": {
            "remove": handleItemRemove,
            "cancel": handleItemCancel,
            "retry": handleItemRetry
          }
        });
      })])]) : h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.buttonPlaceholder
      }, [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.lazy)(placeholder)]), renderValidateStatus()]) : h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_15__.uploadContainerClassName, containerValidateStateClassName)
      }, [h("label", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_15__.uploadZoneContainerClassName, zoneValidateStatusClassName),
        "on": {
          "click": onClick,
          "dragover": handleDragOver,
          "drop": handleFileDrag,
          "dragend": handleDragEnd,
          "dragenter": handleDragEnter,
          "dragleave": handleDragLeave
        }
      }, [h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)('iconfont icon-upload', _style__WEBPACK_IMPORTED_MODULE_15__.uploadIconClassName, 'sl-custom-icon__upload__upload')
      }), h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.uploadTextClassName
      }, [this.i18n.t.upload.drag({
        placeholder: (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.lazy)(placeholder)
      }), ' ', h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.uploadTextButtonClassName(theme)
      }, [this.i18n.t.upload.click])]), h("input", {
        "attrs": {
          "type": 'file',
          "multiple": multiple
        },
        "ref": 'input',
        "class": _style__WEBPACK_IMPORTED_MODULE_15__.hiddenUploadClassName,
        "on": {
          "change": handleInput,
          "click": (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.eventStop)()
        }
      })]), value && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.arrayify)(value).length ? h("div", [h(_list__WEBPACK_IMPORTED_MODULE_13__["default"], [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.arrayify)(value).map(function (x, i) {
        return h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
          "attrs": {
            "value": x,
            "index": i
          },
          "on": {
            "remove": handleItemRemove,
            "cancel": handleItemCancel,
            "retry": handleItemRetry
          }
        });
      })])]) : null, renderValidateStatus()]);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.formItemInstance) {
        this.formItemInstance.setFormComponent(this);
        this.validateState = this.formItemInstance.onMounted();
      }

      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.formItemInstance) {
        this.formItemInstance.resetFormComponent(this);
      }

      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }]);

  return UploadZone;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], UploadZone.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], UploadZone.prototype, "uploadCallback", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], UploadZone.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: false
})], UploadZone.prototype, "multiple", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], UploadZone.prototype, "buttonType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: _locales__WEBPACK_IMPORTED_MODULE_14__["default"].t.upload.file
})], UploadZone.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Inject)({
  from: 'formItemInstance',
  default: null
})], UploadZone.prototype, "_formItemInstance", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Emit)('click')], UploadZone.prototype, "onClick", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Emit)('input')], UploadZone.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Emit)('remove')], UploadZone.prototype, "onRemove", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Inject)({
  from: 'i18nInjection',
  default: null
})], UploadZone.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Provide)('i18nInjection')], UploadZone.prototype, "i18nProvider", void 0);

UploadZone = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], UploadZone);
/* harmony default export */ __webpack_exports__["default"] = (UploadZone);

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/es.array.from.js":
/*!***************************************************!*\
  !*** external "core-js/modules/es.array.from.js" ***!
  \***************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_array_from_js__;

/***/ }),

/***/ "core-js/modules/es.string.iterator.js":
/*!********************************************************!*\
  !*** external "core-js/modules/es.string.iterator.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_string_iterator_js__;

/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/iconfont":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/iconfont","commonjs2":"@splat/iconfont"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_iconfont__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "@splat/validator":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/validator","commonjs2":"@splat/validator"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_validator__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FileStatus": function() { return /* reexport safe */ _types__WEBPACK_IMPORTED_MODULE_3__.FileStatus; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.from.js */ "core-js/modules/es.array.from.js");
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _zone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./zone */ "./src/zone.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./types */ "./src/types.ts");




/* harmony default export */ __webpack_exports__["default"] = (_zone__WEBPACK_IMPORTED_MODULE_2__["default"]);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map